import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

export const useDeliveryTracking = (user) => {
  const [deliveries, setDeliveries] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setDeliveries([]);
      setPendingCount(0);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'Tracking'),
      where('delivered', '==', false),
      orderBy('etaISO', 'asc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const trackingData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Calculate days left for each delivery
        const today = new Date();
        const enrichedData = trackingData.map(item => {
          const etaDate = new Date(item.etaISO);
          etaDate.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);
          
          const diffMs = etaDate.getTime() - today.getTime();
          const daysLeft = Math.round(diffMs / (1000 * 60 * 60 * 24));
          
          return {
            ...item,
            daysLeft,
            formattedEta: etaDate.toLocaleDateString(),
            isOverdue: daysLeft < 0,
            isToday: daysLeft === 0,
            isSoon: daysLeft > 0 && daysLeft <= 2
          };
        });

        setDeliveries(enrichedData);
        setPendingCount(enrichedData.length);
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching delivery tracking:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user]);

  return { deliveries, pendingCount, loading };
};
